import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getShortName } from '@utils/Util';

const CollectionMoveCopy = ({ content, index, onClickCrossIcon, completedIds }) => {
	const navigate = useNavigate();
	const getParcentage = (completed = 1, targetNumber = 0) => {
		return Math.round((completed / targetNumber) * 100);
	};
	return (
		<div className="progress-fixed-bottom" style={{ bottom: `${index === 0 ? 40 : index * 140}px` }}>
			<div className="header d-flex align-items-center justify-content-between">
				<p
					className="regular-12"
					onClick={() => {
						navigate(`/collections/view/${content.collectionId}`);
						completedIds.includes(content.id) && onClickCrossIcon();
					}}
				>
					<span className="semibold-12">
						{content?.opType === 'MOVE' ? 'Moving' : 'Copying'} to
					</span>
					<span className="pl-2 collection-name">{getShortName(content.collectionName, 38)}</span>
					<img
						className="cursor-pointer"
						src={`${process.env.PUBLIC_URL}/icons/external-link.svg`}
						alt="link"
					/>
				</p>

				<div className="close cursor-pointer">
					{completedIds.includes(content.id) && (
						<span onClick={() => onClickCrossIcon()}>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
						</span>
					)}
				</div>
			</div>
			<div className="details d-flex justify-content-between align-items-center">
				<div className="progress-info">
					<div className="progress">
						<div
							className="progress-bar completed"
							role="progressbar"
							// style={{ width: '80%' }}
							style={{
								width: getParcentage(content?.completedCount, content?.totalCount) + '%'
							}}
							// aria-valuenow={15}
							aria-valuemin={0}
							aria-valuemax={100}
						/>
					</div>
				</div>
				<div className="value">
					<p className="semibold-12">
						{' '}
						{content?.completedCount}
						<span className="gray_dark_02">/{content?.totalCount}</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default CollectionMoveCopy;
